import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiBottomSheetComponent } from '../ui-bottom-sheet/ui-bottom-sheet.component';
import { UiButtonComponent } from '../ui-button/ui-button.component';

@Component({
  selector: 'ui-confirm-sheet',
  imports: [UiBottomSheetComponent, UiButtonComponent],
  templateUrl: './ui-confirm-sheet.component.html',
  styleUrl: './ui-confirm-sheet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiConfirmSheetComponent {
  public readonly open: InputSignal<boolean> = input<boolean>(false);
  public readonly title: InputSignal<string> = input.required<string>();
  public readonly description: InputSignal<string> = input.required<string>();
  public readonly primaryLabel: InputSignal<string> = input<string>('Potwierdź');
  public readonly cancelLabel: InputSignal<string> = input<string>('Anuluj');
  public readonly closeLabel: InputSignal<string> = input<string>('Zamknij');
  public readonly destructive: InputSignal<boolean> = input<boolean>(false);
  public readonly confirmed: OutputEmitterRef<void> = output<void>();
  public readonly cancelled: OutputEmitterRef<void> = output<void>();
  public readonly closed: OutputEmitterRef<void> = output<void>();

  protected readonly isDestructive: Signal<boolean> = computed((): boolean => this.destructive());

  protected handleConfirmed(): void {
    this.confirmed.emit();
  }

  protected handleCancelled(): void {
    this.cancelled.emit();
  }

  protected handleClosed(): void {
    this.closed.emit();
  }
}
